module.exports = __webpack_public_path__ + "static/media/bird-loon2.ad4d5f08.aac";